import { render, staticRenderFns } from "./testDown.vue?vue&type=template&id=056fabc8&"
import script from "./testDown.vue?vue&type=script&lang=js&"
export * from "./testDown.vue?vue&type=script&lang=js&"
import style0 from "./testDown.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports